import { Component,Injectable, OnInit } from '@angular/core';
import { CommonService } from '../service/common.service';
import { EventService } from '../service/event.service';
import { AdminshareService } from "../service/adminshare.service";
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { DatePipe } from '@angular/common';
import { NgbInputDatepicker,NgbDatepickerI18n,NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '../service/users.service';
import { Role } from '../app.constant';

const I18N_VALUES = {
  'ja': {
      weekdays: ['月', '火', '水', '木', '金', '土', '日'],
      months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    }
  };
   
@Injectable()
export class I18n {
    language = 'ja';
}
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  constructor(private _i18n: I18n) {
    super();
  }
  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }
}
  @Component({
    selector: 'event-app',
    templateUrl: './event.component.html',
    styleUrls: ['event.component.css'],
    providers: [I18n, {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n}]
})

  export class EventComponent implements OnInit {
    title : string = 'イベント一覧';

    page : number = 1;
    all_count:number=0;
    display_per_page:  number = 20;   /* 最大表示件数 */

    isLoaded : boolean = false;
    selected : boolean = false;
    datalist : any = [];
    all_datalist: any = [];
    mendan_flg : any;
    
    displayMonths = 2;
    ROLE: any = Role;
    content_list_info:any={
        'name_name':'タイトル',
        'name_description':'説明文',
        'name_support':'タイトルを入力してください',
        'description_support':'説明文を入力してください',
        'data' : {},
        'languagelist' : [
        ],
    };
    constructor(
        public commonService: CommonService,
        private adminShareService: AdminshareService,
        public usersService: UsersService,
        private eventService: EventService,
        private router: Router,
        private location: Location,

    ) { }

    ngOnInit(): void {
        this.getList();
        //画面上部へ移動
        window.scrollTo(0, 0);
    };

    searchEventPages(eid):number{

        var hairetu;
        for(let i in this.all_datalist){
            if (this.all_datalist[i]['id']==eid){
                hairetu = i;
            }
        }
        return (hairetu/this.display_per_page|0)+1;
    }

    clearData (): void{
        this.isLoaded = false;
        this.editSelectRowData(undefined);
        this.selected = false;
        this.datalist = [];
    }

    getList(): void {
        this.clearData();
        let param ={
            publish_mode:2,
            page:this.page,
            display_per_page:this.display_per_page
        };
        this.eventService.getEvent(param)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                this.all_count = res["fuel_results"]["all_count"];
                this.all_datalist = res["fuel_results"]["event"];

                this.content_list_info.languagelist= res["fuel_results"]['language'];

                this.mendan_flg = res["fuel_results"]["mendan"];   
                
                if(this.adminShareService.set_edit_event != null){
                    this.edit(this.adminShareService.set_edit_event);
                    //何ページ目に所属するか
                    this.page = this.searchEventPages(this.adminShareService.set_edit_event.id);
        
                    this.adminShareService.set_edit_event = null;            
                }

                this.changePage(this.page);
                this.isLoaded = true;

            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }

    save():void{
        this.commonService.modalOpens(50001,
            //保存してもよろしいですか？
            modalresult => {
                if (modalresult == "OK"){
                    this.content_list_info.data.publish_flg = this.commonService.exchangeTFto01(this.content_list_info.data.publish_flg);
                    this.content_list_info.data.hiro_flg = this.commonService.exchangeTFto01(this.content_list_info.data.hiro_flg);
                    this.content_list_info.data.suimin_flg = this.commonService.exchangeTFto01(this.content_list_info.data.suimin_flg);

                    this.content_list_info.data.publish_date_start = this.commonService.exchangeDateFormat2(this.content_list_info.data.publish_date_start);
                    this.content_list_info.data.publish_date_end = this.commonService.exchangeDateFormat2(this.content_list_info.data.publish_date_end);
                    this.content_list_info.data.reply_date_start = this.commonService.exchangeDateFormat2(this.content_list_info.data.reply_date_start);
                    this.content_list_info.data.reply_date_end = this.commonService.exchangeDateFormat2(this.content_list_info.data.reply_date_end);

                    this.eventService.save(this.content_list_info.data)
                    .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10001,modalresult=>{
                                    if (modalresult == "OK"){
                                        this.editSelectRowData(undefined);
                                        this.selected = false;
                                        this.page = 1;
                                        this.getList();
                                     }
                                });
                            }else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                            }else{
                                this.commonService.modalOpens(11003,modalresult=>{});
                            }
                        },error => {
                            this.commonService.modalOpens(error,modalresult=>{});
                        });
                }else{
                    //
                }
            }
        );
    }

    cancel() {
        this.commonService.modalOpens(50005,
        //編集中の内容を破棄してもよろしいですか？
             modalresult => {
                if (modalresult == "OK"){
                    this.editSelectRowData(undefined);
                    this.selected = false;
                }else{

                }
            }
        );
    }

    delete():void{
        this.commonService.modalOpens(50002,
            //削除してもよろしいですか？
            modalresult => {
                if (modalresult == "OK"){
                    this.eventService.delete(this.content_list_info.data)
                    .subscribe((res: Response) => {
                        if (res["fuel_status"] == "OK") {
                            this.commonService.modalOpens(10002,modalresult=>{
                                this.editSelectRowData(undefined);
                                this.selected = false;
                                this.page = 1;
                                this.getList();
                            });
                        }else if (res["fuel_status"] == "NG") {
                            this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                        }else{
                            this.commonService.modalOpens(11003,modalresult=>{});
                        }
                    },error => {
                        this.commonService.modalOpens(error,modalresult=>{});
                    });
            }else{
                    //
            }
            }
        );
    }
    // 編集
    edit(row: any): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.editSelectRowData(row);
                        //画面上部へ移動
                        window.scrollTo(0, 0);
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.editSelectRowData(row);
            //画面上部へ移動
            window.scrollTo(0, 0);
        }
    }

    editSelectRowData(row: any): void {

        if (row == undefined){
            this.selected = true;
            this.content_list_info.data =  {
                id:null,
                m_contract_company_id:null,
                t_execution_plan_id:null,
                publish_date_start:null,
                publish_date_end:null,
                reply_date_start:null,
                reply_date_end:null,
                publish_flg:false,
                hiro_flg:false,
                suimin_flg:false,
                update_datetime:null,
                content:[
                    { m_language_id: null,
                      title_name: null,
                      description: "",
                    }
                ],
                list_edit_flg : true
            };
        }else{
            this.selected = true;
            this.content_list_info.data = JSON.parse(JSON.stringify(row))
            this.content_list_info.data.publish_date_start = this.commonService.exchangeDateFormat1(this.content_list_info.data.publish_date_start);
            this.content_list_info.data.publish_date_end = this.commonService.exchangeDateFormat1(this.content_list_info.data.publish_date_end);
            this.content_list_info.data.reply_date_start = this.commonService.exchangeDateFormat1(this.content_list_info.data.reply_date_start);
            this.content_list_info.data.reply_date_end = this.commonService.exchangeDateFormat1(this.content_list_info.data.reply_date_end);
            this.content_list_info.data.publish_flg = this.commonService.exchange01toTF(this.content_list_info.data.publish_flg);
            this.content_list_info.data.hiro_flg = this.commonService.exchange01toTF(this.content_list_info.data.hiro_flg);
            this.content_list_info.data.suimin_flg = this.commonService.exchange01toTF(this.content_list_info.data.suimin_flg);
            this.content_list_info.data.list_edit_flg = true;
            this.content_list_info.data.yoyaku_check_flg = this.checkYoyakuData(this.content_list_info.data.content);
        }
    }

    checkList():boolean{
        //設問カテゴリの言語エラーを一度初期化
        this.content_list_info.duplicateError = false;

        var tempList = this.content_list_info.data;
        var row = tempList.content.filter(
            item => 
                item.m_language_id == null 
                || item.title_name == null 
                || item.title_name == "" 
                || item.title_name.length > 128 
                || (item.description !=null? item.description.length> 1000 : item.description ==null)
          );  
        if (row.length > 0) {
            return true;
        } else {
            if( tempList.reply_date_start == null ||
                tempList.reply_date_end == null || 
                tempList.publish_date_start == null || 
                tempList.publish_date_end == null ){
                return true;
            }else{
                if( this.checkDate(1) ||
                    this.checkDate(2) || 
                    this.checkDate(3) || 
                    this.checkDate(4) ){
                    return true;
                }else{
                    //言語数以上登録されていないか
                    if(this.content_list_info.languagelist.length < tempList.content.length){
                        return true;
                    }else{
                        //言語IDが複数ないか
                        let dupcheckList = this.commonService.checkDuplicateRecords(tempList.content,'m_language_id');
                        if (dupcheckList.length < tempList.content.length){
                            return true;
                        }
                        
                        //duplicate_lang
                        if(this.content_list_info.data.duplicate_lang != null && this.content_list_info.data.duplicate_lang.length > 0){
                            for(let i in tempList.content){
                                let row = this.content_list_info.data.duplicate_lang.filter(
                                    item => item == tempList.content[i]['m_language_id']
                                );  
    
                                if(row.length==0){
                                    //NG
                                    this.content_list_info.duplicateError = true;
                                    return true;
                                }
                            }
                        }
                        //yoyaku_duplicate_lang
                        if(this.content_list_info.data.yoyaku_duplicate_lang != null && this.content_list_info.data.yoyaku_duplicate_lang.length > 0){
                            for(let i in tempList.content){
                                let row = this.content_list_info.data.yoyaku_duplicate_lang.filter(
                                    item => item == tempList.content[i]['m_language_id']
                                );  
    
                                if(row.length==0){
                                    //NG
                                    this.content_list_info.duplicateError = true;
                                    return true;
                                }
                            }
                        }
                        
                        return false;
                    }
                }
            }
        }
    }

    checkDate(mode:number):boolean{
        switch (mode){
            //reply大小
            case 1:
                if( this.content_list_info.data.reply_date_start == null || this.content_list_info.data.reply_date_end == null){
                    return false;
                } else {
                    if( this.commonService.exchangeDateFormat2(this.content_list_info.data.reply_date_start) > this.commonService.exchangeDateFormat2(this.content_list_info.data.reply_date_end)){
                        return true;
                    } else {
                        return false;
                    }
                }
            //publish大小
            case 2:
                if( this.content_list_info.data.publish_date_start == null || this.content_list_info.data.publish_date_end == null){
                    return false;
                } else {
                    if( this.commonService.exchangeDateFormat2(this.content_list_info.data.publish_date_start) > this.commonService.exchangeDateFormat2(this.content_list_info.data.publish_date_end)){
                        return true;
                    } else {
                        return false;
                    }
                }
            //開始大小
            case 3:
                if( this.content_list_info.data.reply_date_start == null || this.content_list_info.data.publish_date_start == null){
                    return false;
                } else {
                    if( this.commonService.exchangeDateFormat2(this.content_list_info.data.reply_date_start) < this.commonService.exchangeDateFormat2(this.content_list_info.data.publish_date_start)){
                        return true;
                    } else {
                        return false;
                    }
                }
            //終了大小
            case 4:
                if( this.content_list_info.data.reply_date_end == null || this.content_list_info.data.publish_date_end == null){
                    return false;
                } else {
                    if( this.commonService.exchangeDateFormat2(this.content_list_info.data.reply_date_end) > this.commonService.exchangeDateFormat2(this.content_list_info.data.publish_date_end)){
                        return true;
                    } else {
                        return false;
                    }
                }
      }
    }
    checkYoyakuData(data:any):boolean {
        var tmp = [];
        var yoyaku_data = [];
        tmp = data.filter(item => item.yoyakuhyo.length>0);
        if (tmp.length==0){
            return false;
        } else {
            for(let i=0; tmp.length>i; i++){
                for(let c=0; tmp[i].yoyakuhyo.length>c; c++){
                    yoyaku_data.push(tmp[i].yoyakuhyo[c]);
                }
            }
            yoyaku_data.filter(item => item.count_yoyaku>0);
            if (yoyaku_data.length>0){
                return true;
            } else {
                return false;
            }
        }
    }
    changePage(e){
        var start = (e-1)*this.display_per_page;
        this.datalist = this.all_datalist.slice(start, start+this.display_per_page);
    }
    //a0102問診の編集
    setQuestion(row: any): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.adminShareService.set_question_category={
                            event_id:row.id,
                            temp_selected_list:[]
                        };
                        this.router.navigate(["/question-category/"+row.id]);
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.adminShareService.set_question_category={
                event_id:row.id,
                temp_selected_list:[]
            };
            this.router.navigate(["/question-category/"+row.id]);
        }
    }
    //予約表をイベントに設定する
    setYoyakuhyo(row: any): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.adminShareService.set_question_category={
                            event_id:row.id,
                            temp_selected_list:[]
                        };
                        this.router.navigate(["/yoyaku-hyo/"+row.id]);
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.adminShareService.set_question_category={
                event_id:row.id,
                temp_selected_list:[]
            };
            this.router.navigate(["/yoyaku-hyo/"+row.id]);
        }
    }
    goQuestionList(qcid,m_language_id): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.router.navigate(["/question-list/" + qcid + "/" + m_language_id]);
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.router.navigate(["/question-list/" + qcid + "/" + m_language_id]);
        }
      }
      
    goYoyakuList(yhid,m_language_id): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.router.navigate(["/yoyaku-list/" + yhid]);
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.router.navigate(["/yoyaku-list/" + yhid]);
        }
    }
    //a0108個人データ
    setPerson(row: any): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.router.navigate(["/person/"+row.id]);
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.router.navigate(["/person/"+row.id]);
        }
    }
    //a0106メール配信
    goMail(row: any): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        //テンポラリクリア
                        this.adminShareService.from_page = "";
                        this.adminShareService.temp_send_list = [];                
                        this.router.navigate(["/mail/" + row.id]);
                    }else{
                        return;
                    }
                }
            );
        }else{
                        //テンポラリクリア
                        this.adminShareService.from_page = "";
                        this.adminShareService.temp_send_list = [];                
                        this.router.navigate(["/mail/" + row.id]);
        }
    }
    //a0107状況確認
    goProgress(row: any): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.router.navigate(["/progress/"+row.id]);
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.router.navigate(["/progress/"+row.id]);
        }
    }
    //メンテナンス
    goMaintenance(row: any): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.router.navigate(["/maintenance/"+row.id]);
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.router.navigate(["/maintenance/"+row.id]);
        }
    }
    goAnalysis(tqcId: Number, langId:Number){
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.router.navigate(["/result-analysis/"+tqcId+"/"+langId]);
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.router.navigate(["/result-analysis/"+tqcId+"/"+langId]);
        }
    }
    goBack(): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.location.back();
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.location.back();
        }
    }

    /**
     * 切り替えるDatePicker以外を閉じながら、
     * toggleで表示非表示を切り替える
     * 
     * @param selectDp 切り替えるDatePicker
     * @param subDp1 閉じるDatePicker1
     * @param subDp2 閉じるDatePicker2
     * @param subDp3 閉じるDatePicker3
     */
    toggleDate(selectDp: NgbInputDatepicker, subDp1: NgbInputDatepicker, subDp2: NgbInputDatepicker, subDp3: NgbInputDatepicker): void{
        selectDp.toggle();
        subDp1.close();
        subDp2.close();
        subDp3.close();
    }

    //a2128アップロード設定
    goUploadsetting(row: any): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.router.navigate(["/upload-setting/"+row.id]);
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.router.navigate(["/upload-setting/"+row.id]);
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/a0101-event/event.component.ts